import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export function LoginButton() {
  const navigate = useNavigate();

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={() => navigate("/login")}
      sx={{
        textTransform: "none",
        borderColor: "divider",
        color: "text.primary",
        "&:hover": {
          borderColor: "primary.main",
          color: "primary.main"
        }
      }}
    >
      Log In
    </Button>
  );
}
